export default String.raw`
<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{ translations.Downloads }}
	</div>
	{% if customer.CompanyErpId <= 0 -%}
		<div class="no-data">{{ translations.AccessDenied }}</div>
	{% else %}
	<div class="eshop__table-container erp-data-js" style="display: none">
		<table>
			<colgroup>
				<col style="width:120px">
			</colgroup>
			<thead>
				<tr>
					<th class="id">{{ translations.FileName }}</th>
					<th>{{ translations.Downloads }}</th>
				</tr>
			</thead>
				<div class="row to-download-table-js table-js" data-sp="CDN.eshop_GetCustomerFiles">
					<tbody>
						<tr class="row parent-container-reload-js" rv-each-o="List">
							<div rv-if="o.IsUrl">
								<td class="id" rv-if="o.IsUrl">
									<div class="download-file">
										<i class="file-to-download-icon-js" rv-data-extension="o.Extension">
											<svg width="24" height="24" class="svgIcon">
												<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use>
											</svg>
										</i>
										{ o.Name }
									</div>
								</td>
								<td rv-if="o.IsUrl"><a class="download-file pure-button" rv-href="o.UrlValue" target="_blank">{{ translations.DownloadFile }}</a></td>
							</div>
							<div rv-unless="o.IsUrl">
								<td class="id">
									<div class="download-file">
										<i class="file-to-download-icon-js" rv-data-extension="o.Extension">
											<svg width="24" height="24" class="svgIcon">
												<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use>
											</svg>
										</i>
										{ o.Name }
									</div>
								</td>
								<td class="download-file-from-to-download-js" rv-data-id="o.ID" rv-data-extension="o.Extension">
									<div class="download-file pure-button">
										{{ translations.DownloadFile }}
									</div>
								</td>
							</div>
						</tr>
					</tbody>
				</div>
		</table>
		<div class="no-data">{{ translations.NoFiles }}</div>
		{% include 'partials/customer-profile/pagination.html' -%}
	</div>
	<div class="loader-js loader big"></div>
	{% endif -%}
</div>
`